/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_No_Times_TitleInputs */

const en_services_no_times_title = /** @type {(inputs: Services_No_Times_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No open times right now`)
};

const pl_services_no_times_title = /** @type {(inputs: Services_No_Times_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak wolnych terminów`)
};

/**
* | output |
* | --- |
* | "No open times right now" |
*
* @param {Services_No_Times_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const services_no_times_title = /** @type {((inputs?: Services_No_Times_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_No_Times_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_services_no_times_title(inputs)
	return en_services_no_times_title(inputs)
});